module.exports = __webpack_public_path__ + "img/battery_high.a90d371b.svg";